import React from 'react';
import { useParams } from 'react-router';
import styled from 'styled-components';
import { TenantWithActions } from '../../redux/selectors';
import TenantListItem from './tenant-list-item';

interface TenantListProps {
  tenants: TenantWithActions[];
  onDeleteClick?: (id: string) => void;
  flush?: boolean;
  hideButtons?: boolean;
  tenancyId?: string;
  tenancyOrderStatus: string;
}

const TenantListWrapper = styled.ul<{ flush?: boolean }>`
  background: #fff;
  margin: ${(props) => (props.flush ? '0' : '22px 0')};
  min-width: 200px;
  overflow: hidden;
  padding: 0;

  > div:last-child {
    margin-bottom: ${(props) => (props.flush ? '0' : '6px')};
  }
`;

const TenantList: React.SFC<TenantListProps> = ({
  onDeleteClick,
  tenants,
  flush,
  hideButtons,
  tenancyId,
  tenancyOrderStatus,
}) => {
  const { id: tenancyOrderId } = useParams<{ id: string }>();
  return (
    <TenantListWrapper flush={flush}>
      {tenants.map(
        (tenant) =>
          tenancyId && (
            <TenantListItem
              key={tenant.id}
              tenant={tenant}
              onDeleteClick={onDeleteClick}
              hideButtons={hideButtons}
              tenancyId={tenancyId}
              tenancyOrderId={tenancyOrderId}
              tenancyOrderStatus={tenancyOrderStatus}
            />
          ),
      )}
    </TenantListWrapper>
  );
};

export default TenantList;
